module.exports = __webpack_public_path__ + "static/pattern-design-07-b13006c6e2c5414197ee2b40b00653e3.jpg";